module.exports =
  signatureTemplate: """
  <table style="border-spacing: 0px; font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; page-break-inside: avoid !important;">
    <tr style="padding: 0; margin: 0;">
      <td rowspan="5" style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <img src="{{URL_BROKER_LOGO}}" width="180" />
      </td>
      <td colspan="2" style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <span  style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; font-weight: bold;">{{name}}</span>
      </td>
    </tr>

    <tr style="padding: 0; margin: 0;">
      <td colspan="2" style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <span  style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; font-weight: bold;">{{commercialName}}</span>
      </td>
    </tr>

    <tr style="padding: 0; margin: 0;">
      <td colspan="2" style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <span  style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{fullAddress}}</span>
      </td>
    </tr>

    <tr style="padding: 0; margin: 0;">
      <td style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <span  style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{emails}}</span>
      </td>
      <td style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <span  style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{website}}</span>
      </td>
    </tr>

    <tr style="padding: 0; margin: 0;">
      <td colspan="2" style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal; padding: 1px; margin: 0;">
        <span style="{{faxAndPhoneAdditionalCss}} font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{phoneNumbers}}</span>
        <span style="{{faxAndPhoneAdditionalCss}} font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{fax}}</span>
        {{faxAndPhoneSeparator}}
        <span style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{fsma}}</span>
        <span style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{companyRegistrationNumber}}</span>
        <span style="font-size: 11pt; font-family: Arial; font-style: normal; font-variant: normal;">{{signatureText}}</span>
      </td>
    </tr>

    </table>
  """



// WEBPACK FOOTER //
// ./components/office/signatureTemplate.coffee